import React, { useState } from "react";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const ConjointQuestions = ({ respondentId, surveyLink, type, conjoint, action }) => {

    // Create a copy of the conjoint object with the respondent_id set
    const conjointWithRespondentId = { ...conjoint, respondent_id: respondentId };

    // Initialize state
    const [currentIndex, setCurrentIndex] = useState(0);
    const [conjointData, setConjointData] = useState(conjointWithRespondentId);
    const [showNext, setShowNext] = useState(false);

    // Handle choice selection
    const handleChoice = (optionId) => {
        setConjointData((prevState) => {
            const updatedSets = prevState.conjoint_sets.map((set, index) => {
                if (index === currentIndex) {
                    // Update the current choice set immutably
                    const updatedChoiceSet = set.choice_set.map((option) => ({
                        ...option,
                        chosen: option.option_id === optionId,
                    }));

                    return { ...set, choice_set: updatedChoiceSet };
                }
                return set; // Return unchanged sets
            });

            return { ...prevState, conjoint_sets: updatedSets };
        });

        // Move to the next choice set
        if (currentIndex < conjointData.conjoint_sets.length - 1) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
            // if (type === "survey") {
            //     dispatch(answerSurvey(surveyLink, "conjoint", conjointData));
            // }
            setShowNext(true);
        }
    };

    // Render the current choice set
    const conjointOptions = () => {
        const currentSet = conjointData.conjoint_sets[currentIndex];

        return (
            <Box >
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Task {currentSet.task_id} of {conjointData.conjoint_sets.length}
                </Typography>

                {/* Grid layout */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: `1fr repeat(${currentSet.choice_set.length}, minmax(200px, 1fr))`,
                        gap: 2,
                    }}
                >
                    {/* Attributes Column */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            // alignItems: "center",
                        }}
                    >
                        {/* Spacer for aligning with option titles */}
                        <Box sx={{ height: "60px" }} />
                        {conjoint.attributes_name.map((attribute, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "50px", // Same height as rows in options
                                }}
                            >
                                <Typography sx={{ fontWeight: "bold" }}>
                                    {attribute}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* Options Columns */}
                    {currentSet.choice_set.map((option) => (
                        <Card
                            key={option.option_id}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                            }}
                        >
                            <CardContent>
                                {/* Option Header */}
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        mb: 2,
                                        textAlign: "center",
                                    }}
                                >
                                    {option.option_id === "None"
                                        ? "None of them"
                                        : `Option ${option.option_id}`}
                                </Typography>

                                {/* Option Attributes */}
                                <Stack spacing={0} alignItems="center">
                                    {conjoint.attributes_name.map((attribute) => (
                                        <Box
                                            key={attribute}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                height: "50px", // Aligns rows
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Typography>
                                                {option.attributes[attribute] ??
                                                    ""}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </CardContent>
                            <CardActions
                                sx={{
                                    marginTop: "auto",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => handleChoice(option.option_id)}
                                    disabled={showNext}
                                >
                                    Select
                                </Button>
                            </CardActions>
                        </Card>
                    ))}
                </Box>
            </Box>
        );
    };

    return (
        <Box>
            {conjointOptions()}

            {showNext ?
                <React.Fragment>
                    {/* <Divider sx={{ mt: 5 }} /> */}
                    {action(conjointData)}
                </React.Fragment>
                : null}
        </Box>
    )

};

export default ConjointQuestions